export default __webpack_public_path__ + "static/card_side_button_3-28010f3ed2c4a08887020723f6dc7401.png";